import { useState } from "react";
import { Message } from "../store/types";
import { ScrollAction, ScrollFrom } from "./useReadScrollToBottom";
import { sleep } from "../utils/async";

export const useFileLoaded = (msg: Message) => {
  const [loadError, setLoadError] = useState(false);

  const onload = async () => {
    if (msg.isNewMsg) {
      // 新消息过来，延迟一点点，等待加载完成再滚动到底部
      await sleep(100);
      msg.handleScrollToBottom?.(ScrollAction.AUTO, ScrollFrom.FILE_LOADED);
    }
  };

  const onError = () => {
    setLoadError(true);
  };
  return {
    onload,
    onError,
    loadError,
  };
};
